module.exports = __webpack_public_path__ + "img/violet_022.af04e1e0.png";